<template>
	<div class="nat-detail-container">
		<!--头部-->
		<div class="jc-page-header">
			<el-page-header show-back-icon :title="$t('nat.text.nat')" @back="jumpToUp()" class="relative">
				<template slot="content">
					<span class="long-name" :title="gridData.name">
						{{ gridData.name }}
					</span>
					<div class="jc-list__header--right jc-box-action">
						<a :href="Config.NAT_HELP_URL" target="_blank">{{ $t('nat.text.helpDoc') }}</a>
						<!--操作-->
						<drop-down-operation :buttonTitle="$t('privateNetInstance.operate')" :operations='ops'
							@clickSelectItem="clickOperate">
						</drop-down-operation>
					</div>
				</template>
			</el-page-header>
		</div>
		<div class="jc-page-content">
			<el-tabs type="border-card" v-model="tabName">
				<!--资源信息-->
				<el-tab-pane :label="$t('detail.text.sourceInfo')" name="sourceInfo" :disabled="tabName === 'sourceInfo'">
					<!--基本信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.baseInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list align-left">
								<el-row>
									<!--ID-->
									<el-col :span="8">
										<el-form-item :label="$t('detail.text.id') | withColon">
											<p>
												<span>{{ gridData.natGatewayId }}</span>
												<copy-value :copyVal="gridData.natGatewayId"></copy-value>
											</p>
										</el-form-item>
									</el-col>
									<!-- 名字 -->
									<el-col :span="8">
										<el-form-item :label="$t('nat.text.name') | withColon" class="edit-jc-form">
											<span>{{ gridData.name }}</span>
											<el-popover ref="editValue" trigger="click" :visible-arrow="false" :offset="0"
												placement="left-start" :width="300" v-if="showEditName"
												:value="showEditName">
												<edit-value :inputVal="gridData.name" v-if="showEditName"
													@sureEdit="editName" :inputValRule="rules.name"
													:showEditDes.sync="showEditName"
													:popTitle="$t('privateNetwork.editName')">
												</edit-value>
											</el-popover>
											<el-button type="text" icon="jc-icon-edit" @click="showEditName = true"
												v-popover:editValue>
											</el-button>
											<div class="jc-colude-mask" v-if="showEditName"></div>
										</el-form-item>
									</el-col>
									<!--地域-->
									<el-col :span="8">
										<el-form-item :label="$t('create.text.region') | withColon">
											<p>{{ regions[this.region] | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
								</el-row>
								<!--可用区-->
								<el-form-item :label="$t('create.text.az') | withColon">
									<p>{{ gridData.az }}</p>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<el-divider></el-divider>
					<!--计费信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('eip.text.billInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline align-left">
								<el-row :gutter="20">
									<el-col :span="8">
										<!--计费类型-->
										<el-form-item :label="$t('detail.text.billingType') | withColon">
											<p>{{ gridData.chargeModeName | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--创建时间-->
										<el-form-item :label="$t('detail.text.createTime') | withColon">
											<p>{{ gridData.charge ? gridData.charge.chargeStartTime : '' | maybeEmpty }}</p>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--到期时间（计费类型为包年包月时显示）-->
										<el-form-item :label="$t('detail.text.expireTime') | withColon"
											v-if="gridData.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION">
											<p>{{ gridData.charge ? gridData.charge.chargeExpiredTime : '' | maybeEmpty }}
											</p>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
					<el-divider></el-divider>
					<!--配置信息-->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.configurationInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list">
								<!--规格-->
								<el-form-item :label="$t('create.text.spec') | withColon">
									<p> {{ transformType(gridData.natGatewayType) + $t('nat.text.choosedSpecification',
										[SpecTypeParamsDicts[gridData.natGatewayType]]) }}</p>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<el-divider></el-divider>
					<!-- 网络信息 -->
					<div class="jc-section">
						<div class="jc-section-header">
							<h3 class="jc-section-title">{{ $t('detail.text.netInfo') }}</h3>
						</div>
						<div class="jc-section-content">
							<el-form class="jc-datashow-list jc-datashow-list-inline">
								<el-row :gutter="20">
									<el-col :span="8">
										<!--私有网络-->
										<el-form-item :label="$t('subnet.text.privateNetwork') | withColon">
											<a href="javascript:void(0)"
												@click="jumpToVpcDetail(gridData.vpcId, gridData.region)">
												{{ gridData.vpcName | maybeEmpty }}
											</a>
											<span>{{ ' (' + gridData.vpcCidr + ')' }}</span>
										</el-form-item>
									</el-col>
									<el-col :span="8">
										<!--已绑定EIP-->
										<el-form-item :label="$t('nat.text.bondedEip') | withColon">
											<a href="javascript:void(0)" @click="jumpToNatEipDetail(gridData)">
												{{ gridData.eipNum }}
											</a>
										</el-form-item>
									</el-col>
								</el-row>
							</el-form>
						</div>
					</div>
				</el-tab-pane>
				<!-- 弹性公网IP -->
				<el-tab-pane :label="$t('eip.text.eip')" name="eip" :disabled="tabName === 'eip'">
					<span>{{ $t('nat.speechCraft.natTip') }}</span>
					<el-table :data="gridData.eipList" :empty-text="$t('speechCraft.listNoText')" style="margin-top:10px">
						<el-table-column prop="eipId" :label="$t('eip.text.eip')">
							<template slot-scope="scope">
								<span>{{ scope.row.elasticIp }}</span>
							</template>
						</el-table-column>
						<el-table-column :label="$t('nat.text.boundRules')" key="boundRules">
							<template slot-scope="scope">
								<p>
									<span>{{ $t('nat.text.snat') | withColon }}</span>
									<a href="javascript:void(0)" @click="jumpToSnatTab">
										{{ scope.row.snatCount }}
									</a>
								</p>
								<p>
									<span>{{ $t('nat.text.dnat') | withColon }}</span>
									<a href="javascript:void(0)" @click="jumpToDnatTab">
										{{ scope.row.dnatCount }}
									</a>
								</p>
							</template>
						</el-table-column>
						<el-table-column :label="$t('privateNetInstance.listTitle.operate')" key="operation">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="openUnBindSourceDialog(scope.row)">
									{{ $t('privateNetInstance.operations.unbind') }}
								</a>
								<!--解绑资源-->
								<un-bind-eip :visible.sync="unBindSourcedDialogVisible" @ifDialogVisible="syncUnbindDialog"
									:region="gridDatas.region" :rowInfo="gridDatas" :natId="gridData.natGatewayId"
									@refresh="getServerData">
								</un-bind-eip>
							</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<!-- SNAT规则 -->
				<el-tab-pane :label="$t('nat.text.snat')" name="snat" :disabled="tabName === 'snat'">
					<div class="jc-container-table-actionBar flex-display">
						<el-form class="jc-table-actionBar-item" :inline="true">
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon" @click="refreshSnatList">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-tooltip :disabled="availableSnatQuota > 0 && !disableByChargeStatus"
									:content="snatQuotaTip" placement="bottom" effect="dark">
									<label>
										<el-button type="primary" @click="addSnatRule"
											:disabled="availableSnatQuota <= 0 || disableByChargeStatus">
											{{ $t('nat.text.addSnatRule') }}
										</el-button>
									</label>
								</el-tooltip>
							</el-form-item>
						</el-form>
						<el-form class="jc-box-table-search" :inline="true">
							<el-form-item>
								<el-input :placeholder="placeholderMap[snatSearchType]" v-model="snatSearchVal"
									@keyup.enter.native="handleSnatSearchClick" :maxlength="64" class="search-input"
									v-entire-placeholder>
									<el-select v-model="snatSearchType" @change="snatChangeSearch" slot="prepend"
										class="my-select-select">
										<el-option v-for="(search, index) in snatSearchSelect" :key="index"
											:label="search.searchLabel" :value="search.searchValue">
										</el-option>
									</el-select>
									<el-button slot="append" icon="jc-icon-search" class="search-icon"
										@click="handleSnatSearchClick">
									</el-button>
								</el-input>
							</el-form-item>
						</el-form>
					</div>
					<el-table :data="snatRuleList.tableData" style="width: 100%" class="jc-table-header-cell jc-list-table"
						:empty-text="$t('speechCraft.listEmptyText')" v-loading="snatRuleList.tableDataLoading">
						<!--SNAT规则ID-->
						<el-table-column :label="$t('nat.text.snatRuleId')" key="id" min-width="100">
							<template slot-scope="scope">
								<span>{{ scope.row.snatRuleId }}</span>
							</template>
						</el-table-column>
						<!--SNAT规则粒度-->
						<el-table-column :label="$t('nat.text.snatRuleGranularity')" key="granularity" min-width="80">
							<template slot-scope="scope">
								<span>{{ SnatRuleGranularityMapConstant[scope.row.granularity] }}</span>
							</template>
						</el-table-column>
						<!--源网段/源IP-->
						<el-table-column :label="$t('nat.text.snatOriginalIp')" key="ip" min-width="80">
							<template slot-scope="scope">
								<span v-if="scope.row.granularity === 'subnet'">
									{{ $t('nat.text.subnetCidr', [scope.row.subnetCidr]) }}
									<span v-if="scope.row.secondaryCidr">{{ $t('nat.text.subnetSecondaryCidr',
										[scope.row.secondaryCidr]) }}</span>
								</span>
								<span v-if="scope.row.granularity === 'server'"> {{ scope.row.privateIp }}</span>
								<span v-if="scope.row.granularity === 'custom'">{{ scope.row.customCidr }}</span>
							</template>
						</el-table-column>
						<!--所属子网/所属服务器-->
						<el-table-column :label="$t('nat.text.belongServer')" key="server" min-width="110">
							<template slot-scope="scope">
								<span v-if="scope.row.granularity === 'subnet'">{{ scope.row.subnetId }}</span>
								<span v-if="scope.row.granularity === 'server'">{{ scope.row.instanceId }}</span>
								<span v-if="scope.row.granularity === 'custom'">--</span>
							</template>
						</el-table-column>
						<!--弹性公网IP-->
						<el-table-column :label="$t('nat.text.eip')" key="eip" min-width="80">
							<template slot-scope="scope">
								<span class="selected-ellipsis" :title="scope.row.eips">{{ scope.row.eips }}</span>
							</template>
						</el-table-column>
						<!--描述-->
						<el-table-column :label="$t('nat.text.description')" key="description" min-width="80">
							<template slot-scope="scope">
								<span class="selected-ellipsis" :title="scope.row.description">{{ scope.row.description |
									maybeEmpty }}</span>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column :label="$t('privateNetInstance.listTitle.operate')" key="operation" min-width="80">
							<template slot-scope="scope">
								<el-button type="text" @click="editSnat(scope.row)" :disabled="disableByChargeStatus">
									{{ $t('nat.operations.edit.name') }}
								</el-button>
								<el-button type="text" @click="deleteSnat(scope.row)" :disabled="disableByChargeStatus">
									{{ $t('nat.operations.delete.name') }}
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div v-if="snatRuleList.total > 0" class="cps-page-footer-simple block jc-container-table-actionBar">
						<el-pagination @size-change="handleSnatSizeChange" @current-change="handleSnatCurrentChange"
							:current-page="snatRuleList.currentPage" :page-sizes="snatRuleList.pageSizes"
							:page-size="snatRuleList.pageSize" layout="total, sizes, prev, pager, next, jumper"
							:total="snatRuleList.total">
						</el-pagination>
					</div>
				</el-tab-pane>
				<!-- DNAT规则 -->
				<el-tab-pane :label="$t('nat.text.dnat')" name="dnat" :disabled="tabName === 'dnat'">
					<div class="jc-container-table-actionBar flex-display">
						<el-form class="jc-table-actionBar-item" :inline="true">
							<el-form-item>
								<el-button icon="jc-icon-refresh-line" class="jc-button-icon" @click="refreshDnatList">
								</el-button>
							</el-form-item>
							<el-form-item>
								<el-tooltip :disabled="availableDnatQuota > 0 && !disableByChargeStatus"
									:content="dnatQuotaTip" placement="bottom" effect="dark">
									<label>
										<el-button type="primary" @click="addDnatRule"
											:disabled="availableDnatQuota <= 0 || disableByChargeStatus">
											{{ $t('nat.text.addDnatRule') }}
										</el-button>
									</label>
								</el-tooltip>
							</el-form-item>
						</el-form>
						<el-form class="jc-box-table-search" :inline="true">
							<el-form-item>
								<el-input :placeholder="placeholderMap[dnatSearchType]" v-model="dnatSearchVal"
									@keyup.enter.native="handleDnatSearchClick" :maxlength="64" class="search-input"
									v-entire-placeholder>
									<el-select v-model="dnatSearchType" @change="dnatChangeSearch" slot="prepend"
										class="my-select-select">
										<el-option v-for="(search, index) in dnatSearchSelect" :key="index"
											:label="search.searchLabel" :value="search.searchValue">
										</el-option>
									</el-select>
									<el-button slot="append" icon="jc-icon-search" class="search-icon"
										@click="handleDnatSearchClick">
									</el-button>
								</el-input>
							</el-form-item>
						</el-form>
					</div>
					<el-table :data="dnatRuleList.tableData" style="width: 100%" class="jc-table-header-cell jc-list-table"
						:empty-text="$t('speechCraft.listEmptyText')" v-loading="dnatRuleList.tableDataLoading">
						<!--DNAT规则ID-->
						<el-table-column :label="$t('nat.text.dnatRuleId')" key="id" min-width="100">
							<template slot-scope="scope">
								<span>{{ scope.row.dnatRuleId }}</span>
							</template>
						</el-table-column>
						<!--弹性公网IP-->
						<el-table-column :label="$t('nat.text.eip')" key="eip" min-width="110">
							<template slot-scope="scope">
								<span>{{ scope.row.eip }}</span>
							</template>
						</el-table-column>
						<!--公网端口-->
						<el-table-column :label="$t('nat.text.publicNetPort')" key="port" min-width="80">
							<template slot-scope="scope">
								<span>{{ scope.row.eipPort }}</span>
							</template>
						</el-table-column>
						<!--内网IPv4-->
						<el-table-column :label="$t('nat.text.priIpv4')" key="ipv4" min-width="80">
							<template slot-scope="scope">
								<span>{{ scope.row.privateIp }}</span>
							</template>
						</el-table-column>
						<!--内网端口-->
						<el-table-column :label="$t('nat.text.privatePort')" key="private" min-width="80">
							<template slot-scope="scope">
								<span>{{ scope.row.privatePort }}</span>
							</template>
						</el-table-column>
						<!--支持协议-->
						<el-table-column :label="$t('nat.text.supportProtocol')" key="protocol" min-width="80">
							<template slot-scope="scope">
								<span>{{ scope.row.protocol }}</span>
							</template>
						</el-table-column>
						<!--描述-->
						<el-table-column :label="$t('nat.text.description')" key="description" min-width="80">
							<template slot-scope="scope">
								<span>{{ scope.row.description | maybeEmpty }}</span>
							</template>
						</el-table-column>
						<!--操作-->
						<el-table-column :label="$t('privateNetInstance.listTitle.operate')" key="operation" min-width="80">
							<template slot-scope="scope">
								<el-button type="text" @click="editDnat(scope.row)" :disabled="disableByChargeStatus">
									{{ $t('nat.operations.edit.name') }}
								</el-button>
								<el-button type="text" @click="deleteDnat(scope.row)" :disabled="disableByChargeStatus">
									{{ $t('nat.operations.delete.name') }}
								</el-button>
							</template>
						</el-table-column>
					</el-table>
					<div v-if="dnatRuleList.total > 0" class="cps-page-footer-simple block jc-container-table-actionBar">
						<el-pagination @size-change="handleDnatSizeChange" @current-change="handleDnatCurrentChange"
							:current-page="dnatRuleList.currentPage" :page-sizes="snatRuleList.pageSizes"
							:page-size="dnatRuleList.pageSize" layout="total, sizes, prev, pager, next, jumper"
							:total="dnatRuleList.total">
						</el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div v-if="copyHover" class="jc-tooltip__popper is-dark copy-success" x-placement="bottom">{{
			$t('detail.text.copySuccess') }}
			<div class="popper__arrow copy-success-arrow"></div>
		</div>
		<!-- 绑定eip -->
		<bind-eip v-if="bindDialogVisible" :visible.sync="bindDialogVisible" :region="gridData.region"
			:instanceId="gridData.natGatewayId" :instanceName="gridData.name" :rowInfo="gridData" @refresh="getServerData">
		</bind-eip>
		<!-- 调整规格 -->
		<modify-specification :dialog-visible="modifyDialogVisible" @ifDialogVisible="syncModifyDialogVisibleData"
			:detailData="gridData">
		</modify-specification>
		<!--删除nat-->
		<delete-nat :visible.sync="deleteEipVisible" @refresh="goBack" :rowInfo="gridData" :pageSource="'detail'">
		</delete-nat>
		<!--添加snat规则-->
		<add-snat-rule :visible.sync="addSnatRuleVisible" @refresh="refreshSnatList" :natInfo="gridData" v-if="addSnatRuleVisible">
		</add-snat-rule>
		<!--编辑snat规则-->
		<edit-snat-rule :visible.sync="editSnatRuleVisible" @refresh="refreshSnatList" :natInfo="gridData"
			v-if="editSnatRuleVisible" :rowInfo="gridDatas">
		</edit-snat-rule>
		<!--删除snat规则-->
		<delete-snat-rule :visible.sync="deleteSnatRuleVisible" :region="region" :rowInfo="gridDatas"
			@refresh="refreshSnatList">
		</delete-snat-rule>
		<!--添加dnat规则-->
		<add-dnat-rule :visible.sync="addDnatRuleVisible" @refresh="refreshDnatList" :natInfo="gridData" v-if="addDnatRuleVisible">
		</add-dnat-rule>
		<!--编辑dnat规则-->
		<edit-dnat-rule :visible.sync="editDnatRuleVisible" @refresh="refreshDnatList" :natInfo="gridData"
			v-if="editDnatRuleVisible" :rowInfo="gridDatas">
		</edit-dnat-rule>
		<!--删除dnat规则-->
		<delete-dnat-rule :visible.sync="deleteDnatRuleVisible" :region="region" :rowInfo="gridDatas"
			@refresh="refreshDnatList">
		</delete-dnat-rule>
	</div>
</template>

<script>
import {
	ChargeModeMap,
	EIPAssociateConstant,
	InstanceTypeConstant,
	OverdueConstantArray,
	ArrearConstantArray,
	ServiceCodeConstant,
	ChargeModeConstant,
	NetworkTypeConstant,
	SpecificationTypeSnatMax,
	SpecTypeParamsDicts,
	SpecificationTypeParams,
	azName,
	SnatRuleGranularityMapConstant
} from '@/common/Constants';
import BindEip from '@/components/nat/BindEip';
import UnBindEip from '@/components/nat/UnBindEip';
import copyValue from '@/components/privateNetwork/CopyValue';
import ModifySpecification from '@/components/nat/ModifySpecification';
import DeleteNat from '@/components/nat/DeleteNat';
import editValue from '@/components/privateNetwork/EditValue';
import dropDownOperation from '@/components/privateNetInstance/dropdownOperation/DropdownOperation';
import DeleteSnatRule from '@/components/nat/DeleteSnatRule';
import AddSnatRule from '@/components/nat/AddSnatRule';
import EditSnatRule from '@/components/nat/EditSnatRule';
import AddDnatRule from '@/components/nat/AddDnatRule';
import EditDnatRule from '@/components/nat/EditDnatRule';
import DeleteDnatRule from '@/components/nat/DeleteDnatRule';
import { getSNatRulesApi, getDNatRulesApi } from '@/api/nat/detail/actions';
import { getResourceQuotasApi } from '@/api/common/actions';
export default {
	components: {
		UnBindEip,
		BindEip,
		ModifySpecification,
		DeleteNat,
		editValue,
		copyValue,
		dropDownOperation,
		DeleteSnatRule,
		AddSnatRule,
		EditSnatRule,
		AddDnatRule,
		EditDnatRule,
		DeleteDnatRule
	},
	data() {
		this.SnatRuleGranularityMapConstant = SnatRuleGranularityMapConstant;
		const valName = (rule, value, callback) => {
			const reg = new RegExp('^[a-zA-Z\\\u4e00-\\\u9fa5]([0-9a-zA-Z\\\u4e00-\\\u9fa5-_.:]{1,127})$');
			if (!reg.test(value)) {
				callback(new Error(this.$t('create.help.instanceNameRule')));
			} else {
				callback();
			}
		};
		return {
			natGatewayId: '',
			placeholderMap: {
				snatId: this.$t('privateNetInstance.placeholderId'),
				snatIp: this.$t('nat.placeholder.snatIp'),
				dnatId: this.$t('privateNetInstance.placeholderId'),
				dnatIp: this.$t('nat.placeholder.snatIp'),
				dnatIpv4: this.$t('nat.placeholder.snatIp'),
			},
			snatSearchVal: '',
			snatSearchType: 'snatId',
			snatSearchSelect: [
				{
					searchValue: 'snatId',
					searchLabel: this.$t('nat.text.snatId')
				},
				{
					searchValue: 'snatIp',
					searchLabel: this.$t('nat.text.snatIp')
				},
			],
			dnatSearchVal: "",
			dnatSearchType: 'dnatId',
			dnatSearchSelect: [
				{
					searchValue: 'dnatId',
					searchLabel: this.$t('nat.text.snatId')
				},
				{
					searchValue: 'dnatIp',
					searchLabel: this.$t('nat.text.snatIp')
				},
				{
					searchValue: 'dnatIpv4',
					searchLabel: this.$t('nat.text.priIpv4')
				},
			],
			// SNAT规则列表相关数据
			availableSnatQuota: 0,
			userSnatQuota: 0,
			snatRuleList: {
				tableData: [],
				tableDataLoading: false,
				total: 0,
				pageSize: 10,
				pageSizes: [10, 20, 50, 100],
				currentPage: 1,
			},
			// DNAT规则列表相关数据
			availableDnatQuota: 0,
			userDnatQuota: 0,
			dnatRuleList: {
				tableData: [],
				tableDataLoading: false,
				total: 0,
				pageSize: 10,
				pageSizes: [10, 20, 50, 100],
				currentPage: 1,
			},
			// 支持的操作
			operatesArr: [
				'BIND', // 绑定资源
				'MODIFY', // 调整规格
				'RENEW', // 续费
				'DELETE', // 删除
			],
			// 当前EIP支持的操作
			availableOperatesArray: [],
			// 当前激活的tab标签页
			tabName: 'sourceInfo',
			selectOperate: '1',
			gridData: {
				charge: {}
			},
			// 当前行
			gridDatas: {},
			descriptionFlag: false,
			editObj: {
				editName: '',
				editDescription: ''
			},
			region: '',
			regions: {},
			ops: [],
			showEditName: false,
			rules: {
				name: [
					{
						required: true,
						message: this.$t('privateNetwork.nameNotNull'),
					},
					{
						validator: valName,
					}
				]
			},
			renew: false,
			copyHover: false,
			// 子网对应的云物理服务器列表
			subnetInstanceListData: [],
			// 云物理服务器tab页loading状态
			tableListLoading: false,
			// 云物理服务器个数
			total: 0,
			// 绑定资源弹框是否可见
			bindDialogVisible: false,
			// 解绑资源弹框是否可见
			unBindSourcedDialogVisible: false,
			// 调整规格弹框是否可见
			modifyDialogVisible: false,
			// 删除eip弹框
			deleteEipVisible: false,
			// 添加snat规则弹框
			addSnatRuleVisible: false,
			// 编辑snat规则弹框
			editSnatRuleVisible: false,
			// 删除snat规则弹框
			deleteSnatRuleVisible: false,
			// 添加dnat规则弹框
			addDnatRuleVisible: false,
			// 编辑dnat规则弹框
			editDnatRuleVisible: false,
			// 删除dnat规则弹框
			deleteDnatRuleVisible: false,
		};
	},
	computed: {
		ChargeModeMap: () => ChargeModeMap,
		EIPAssociateConstant: () => EIPAssociateConstant,
		ServiceCodeConstant: () => ServiceCodeConstant,
		InstanceTypeConstant: () => InstanceTypeConstant,
		OverdueConstantArray: () => OverdueConstantArray,
		ArrearConstantArray: () => ArrearConstantArray,
		ChargeModeConstant: () => ChargeModeConstant,
		SpecificationTypeSnatMax: () => SpecificationTypeSnatMax,
		SpecificationTypeParams: () => SpecificationTypeParams,
		SpecTypeParamsDicts: () => SpecTypeParamsDicts,
		azName: () => azName,
		// 判断操作是否应该因不正确的计费状态而被禁用
		disableByChargeStatus() {
			if (OverdueConstantArray.includes(this.gridData.charge.chargeStatus)) {
				return true;
			}
			return false;
		},
		snatQuotaTip() {
			if (this.availableSnatQuota <= 0) {
				return this.$t('nat.help.snatRule', [this.userSnatQuota])
			}
			if (this.disableByChargeStatus) {
				return this.$t('privateNetInstance.operations.overdueTip')
			}
			return ''
		},
		dnatQuotaTip() {
			if (this.availableDnatQuota <= 0) {
				return this.$t('nat.help.dnatRule', [this.userDnatQuota])
			}
			if (this.disableByChargeStatus) {
				return this.$t('privateNetInstance.operations.overdueTip')
			}
			return ''
		}
	},
	mounted() {
		this.natGatewayId = this.$route.query.id;
		this.region = this.$route.query.region;
		this.tabName = this.$route.query.tabName;
		// 获取资源信息tab页数据
		this.getServerData();
		// 获取snat配额及规则数据
		this.refreshSnatList();
		// 获取dnat配额及规则数据
		this.refreshDnatList();
		this.getRegions();
	},
	watch: {

	},
	methods: {
		/**
			* 获得region和regionName对照
		*/
		getRegions() {
			const params = {
				networkType: NetworkTypeConstant.VPC
			};
			Ajax.get('api/cps/getRegions', params).then((res) => {
				if (res.data) {
					res.data.regions.forEach((region) => {
						this.regions[region.region] = region.regionName;
					});
				}
			});
		},
		getServerData() {
			const params = {
				region: this.region,
				natGatewayId: this.natGatewayId
			};
			Ajax.get('/api/cps/nat/findNatGateway', params).then((res) => {
				this.gridData = res.data.natGateway;
				this.gridData.az = azName[res.data.natGateway.az];
				// 格式化计费信息数据
				if (Object.keys(this.gridData.charge).length === 0) {
					this.gridData.chargeModeName = '';
				} else {
					this.gridData.chargeModeName = this.ChargeModeMap[this.gridData.charge.chargeMode.toUpperCase()];
				}
				// 格式化eip列表Snat及Dnat规则数量
				this.gridData.eipList = this.gridData.eipList.map(item => {
					item.snatCount = item.snatCount || 0;
					item.dnatCount = item.dnatCount || 0;
					return item
				});
				this.ops = this.initOperations(this.gridData);
			})
				.catch(async (err) => {

				})
				.finally(() => {
					this.loading = false;
				});
		},
		initOperations() {
			const item = this.gridData;
			const operations = [
				{
					operateName: this.$t('nat.text.adjustSpecification'),
					disabled: !item.charge.chargeStatus || this.disableByChargeStatus,
					value: 'spec',
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.disableByChargeStatus ? this.$t('privateNetInstance.operations.overdueTip') : ''
				},
				{
					operateName: this.$t('privateNetInstance.operations.bind'),
					disabled: !item.charge.chargeStatus || this.disableByChargeStatus,
					value: 'bind',
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.disableByChargeStatus ? this.$t('privateNetInstance.operations.overdueTip') : ''
				},
				{
					operateName: this.$t('privateNetInstance.operations.repay'),
					disabled: !item.charge.chargeStatus,
					value: 'repay',
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : ''
				},
				{
					operateName: this.$t('operations.delete.name'),
					disabled: item.charge.chargeMode === ChargeModeConstant.PREPAID_BY_DURATION || !item.charge.chargeStatus,
					value: 'delete',
					tip: !item.charge.chargeStatus ? this.$t('eip.help.noChargeInfo') : this.$t('operations.delete.tip')
				},
			];
			return operations;
		},
		clickOperate(item) {
			switch (item) {
				case 'bind':
					this.bindDialogVisible = true;
					break;
				case 'spec':
					this.modifyDialogVisible = true;
					break;
				case 'repay':
					this.renews(this.gridData.natGatewayId);
					break;
				case 'delete':
					this.deleteEipVisible = true;
					break;
				default:
					break;
			}
		},
		// 编辑名称
		editName(value) {
			this.renew = false;
			const params = {
				region: this.region,
				natGatewayId: this.gridData.natGatewayId,
				name: value,
				clientToken: this.clientToken
			};
			Ajax.post('/api/cps/nat/modifyName', params)
				.then((res) => {
					if (res.data) {
						this.gridData.name = res.data.natGateway.name;
						this.$message.success(this.$t('privateNetInstance.operateSuccess'));
					}
				}).catch(async (err) => {
					const { response } = err.data;
					try {
						const json = await response.json();
						this.$message.error(json.errmsg);
					} catch (ex) {
						console.log(ex);
					}
				}).finally(() => {
					this.renew = true;
				});
		},
		jumpToUp() {
			this.$router.push({
				name: 'NatList',
				params: { region: this.region }
			});
		},
		jumpToVpcDetail(id, region) {
			this.$router.push({
				path: '/vpc/detail',
				query: {
					id,
					region,
					tabName: 'source'
				}
			});
		},
		jumpToSubnet(id, region) {
			this.$router.push({
				path: '/subnet/detail',
				query: {
					id,
					region
				}
			});
		},
		jumpToNatEipDetail() {
			this.tabName = 'eip';
		},
		transformType(type) {
			switch (type) {
				case 'small':
					return this.$t('nat.text.small');
				case 'medium':
					return this.$t('nat.text.middle');
				case 'large':
					return this.$t('nat.text.large');
				case 'xlarge':
					return this.$t('nat.text.xlarge');
				default:
					return '';
			}
		},
		// 续费
		renews(id) {
			const params = {
				resourceId: id,
				region: this.region,
				serviceCode: ServiceCodeConstant.CPSNAT,
			};
			Ajax.get('/api/order/submitRenew', params).then((res) => {
				const tempOrderId = res.data.tmpOrderId;
				window.location.href = `${this.Config.RENEW_CONSOLE_URL}/orderConfirmPageIp?requestId=${tempOrderId}&resourceType=cpsnat`;
			});
		},
		goBack() {
			this.$router.push({
				path: '/nat/list'
			});
		},
		openUnBindSourceDialog(row) {
			this.gridDatas = row;
			this.unBindSourcedDialogVisible = true;
		},
		// 同步解绑资源子组件传出来的dialog是否展示
		syncUnbindDialog(data) {
			this.unBindSourcedDialogVisible = data;
		},
		syncModifyDialogVisibleData(data) {
			this.modifyDialogVisible = data;
		},
		refreshSnatList() {
			// 获取snat配额
			this.getSnatQuota();
			// 获取资源信息tab页数据,更新eip列表数据
			this.getServerData();
			const params = {};
			this.refreshSnatWithLoading(params)
		},
		refreshSnatWithLoading(params) {
			this.snatRuleList.tableDataLoading = true;
			const defaultParams = {
				region: this.region,
				pageNumber: this.snatRuleList.currentPage,
				pageSize: this.snatRuleList.pageSize,
				natGatewayId: this.natGatewayId
			};
			const realParams = Object.assign({}, defaultParams, params);
			getSNatRulesApi(realParams).then((res) => {
				this.snatRuleList.tableDataLoading = false;
				this.snatRuleList.tableData = res.data.snatRules.map(item => {
					item.eips = item.eips.join(';');
					return item
				});
				this.snatRuleList.total = res.data.totalCount;
			}).catch(async (err) => {
				const { response } = err.data;
				try {
					const json = await response.json();
					this.$message.error(json.errmsg);
				} catch (ex) {
					console.log(ex);
				}
			})
		},
		handleSnatSearchClick() {
			this.snatRuleList.currentPage = 1;
			const params = {};
			if (this.snatSearchVal !== '') {
				if (this.snatSearchType === 'snatIp') {
					params.eip = this.snatSearchVal.replace(/ /g, '');
				} else if (this.snatSearchType === 'snatId') {
					params.snatRuleId = this.snatSearchVal.replace(/ /g, '');
				}
			}
			this.refreshSnatWithLoading(params);
		},
		handleSnatSizeChange(size) {
			this.snatRuleList.pageSize = size;
			this.snatRuleList.currentPage = 1;
			this.refreshSnatWithLoading({});
		},
		handleSnatCurrentChange(val) {
			this.snatRuleList.currentPage = val;
			this.refreshSnatWithLoading({});
		},
		addSnatRule() {
			this.addSnatRuleVisible = true;
		},
		snatChangeSearch() {
			this.snatSearchVal = '';
		},
		dnatChangeSearch() {
			this.dnatSearchVal = '';
		},
		editSnat(row) {
			this.gridDatas = row;
			this.editSnatRuleVisible = true;
		},
		deleteSnat(row) {
			this.gridDatas = row;
			this.deleteSnatRuleVisible = true;
		},
		handleDnatSearchClick() {
			this.dnatRuleList.currentPage = 1;
			const params = {};
			if (this.dnatSearchVal !== '') {
				if (this.dnatSearchType === 'dnatIp') {
					params.eip = this.dnatSearchVal.replace(/ /g, '');
				} else if (this.dnatSearchType === 'dnatId') {
					params.dNatRuleId = this.dnatSearchVal.replace(/ /g, '');
				} else if (this.dnatSearchType === 'dnatIpv4') {
					params.privateIp = this.dnatSearchVal.replace(/ /g, '');
				}
			}
			this.refreshDnatWithLoading(params);
		},
		refreshDnatList() {
			// 获取dnat配额
			this.getDnatQuota();
			// 获取资源信息tab页数据,更新eip列表数据
			this.getServerData();
			const params = {};
			this.refreshDnatWithLoading(params)
		},
		refreshDnatWithLoading(params) {
			this.dnatRuleList.tableDataLoading = true;
			const defaultParams = {
				region: this.region,
				pageNumber: this.dnatRuleList.currentPage,
				pageSize: this.dnatRuleList.pageSize,
				natGatewayId: this.natGatewayId
			};
			const realParams = Object.assign({}, defaultParams, params);
			getDNatRulesApi(realParams).then((res) => {
				this.dnatRuleList.tableDataLoading = false;
				this.dnatRuleList.tableData = res.data.dnatRules;
				this.dnatRuleList.total = res.data.totalCount;
			}).finally(() => {
			});
		},

		handleDnatSizeChange(size) {
			this.dnatRuleList.pageSize = size;
			this.dnatRuleList.currentPage = 1;
			this.refreshDnatWithLoading({});
		},
		handleDnatCurrentChange(val) {
			this.dnatRuleList.currentPage = val;
			this.refreshDnatWithLoading({});
		},

		addDnatRule() {
			this.addDnatRuleVisible = true;
		},
		editDnat(row) {
			this.gridDatas = row;
			this.editDnatRuleVisible = true;
		},
		deleteDnat(row) {
			this.gridDatas = row;
			this.deleteDnatRuleVisible = true;
		},
		jumpToSnatTab() {
			this.tabName = 'snat';
		},
		jumpToDnatTab() {
			this.tabName = 'dnat';
		},

		getSnatQuota() {
			const params = {
				region: this.region,
				resourceId: this.natGatewayId,
				serviceCode: 'cpssnat',
			};
			getResourceQuotasApi(params).then((res) => {
				this.availableSnatQuota = res.data.availableQuota;
				this.userSnatQuota = res.data.userQuota;
			}).finally(() => {
			});

		},
		getDnatQuota() {
			const params = {
				region: this.region,
				resourceId: this.natGatewayId,
				serviceCode: 'cpsdnat',
			};
			getResourceQuotasApi(params).then((res) => {
				this.availableDnatQuota = res.data.availableQuota;
				this.userDnatQuota = res.data.userQuota;
			}).finally(() => {
			});

		},
	}
};
</script>

<style lang="scss">
@import '~@/assets/scss/detailCommon.scss';
@import '~@/assets/scss/paginationCommon';
@import 'style';
</style>



// WEBPACK FOOTER //
// src/views/nat/detail/Detail.vue